import { render, staticRenderFns } from "./aoi-list.vue?vue&type=template&id=81042b06&scoped=true&"
import script from "./aoi-list.vue?vue&type=script&lang=js&"
export * from "./aoi-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81042b06",
  null
  
)

export default component.exports